import { isBrowser } from './isBrowser'

export const isIntersectionObserverAvailable = () =>
  isBrowser() && 'IntersectionObserver' in window
